import { render } from "./VideoInfo.vue?vue&type=template&id=11fa68dc"
import script from "./VideoInfo.vue?vue&type=script&lang=js"
export * from "./VideoInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__